// import React, { useEffect, useRef } from "react";
// import { useSelector } from "react-redux";

// const ApexDonutPieChart = () => {
//   const chartContainerRef = useRef(null);
//   const { dashboardWeldCountByWelder } = useSelector((state) => state.dashboard);
// console.log("dashboardWeldCountByWelder", dashboardWeldCountByWelder);
//   useEffect(() => {
//     const script = document.createElement("script");
//     script.src = "https://cdn.canvasjs.com/canvasjs.min.js";
//     script.onload = () => {
//       const CanvasJS = window.CanvasJS;
//       if (
//         CanvasJS &&
//         chartContainerRef.current &&
//         dashboardWeldCountByWelder?.data
//       ) {
//         const dataPoints = dashboardWeldCountByWelder.data.map((item) => ({
//           y: item.count,
//           legendText: item.name,
//         }));

//         const chart = new CanvasJS.Chart(chartContainerRef.current, {
//           title: {
//             text: "Weld Count by Inspector",
//             fontFamily: "Poppins",
//             fontWeight: "600",
//             horizontalAlign: "left",
//             padding: 10,
//             color: "#464255",
//           },
//           legend: {
//             verticalAlign: "top",
//             horizontalAlign: "right",
//             fontSize: 13,
//             itemWidth: 160,
//             cursor: "pointer",
//             itemWrap: true,
//             markerMargin: 4,
//           },
//           toolTip: {
//             enabled: true,
//           },
//           data: [
//             {
//               indexLabelFontSize: 20,
//               indexLabelFontFamily: "Garamond",
//               indexLabelFontColor: "#464255",
//               indexLabelLineColor: "#464255",
//               indexLabelPlacement: "outside",
//               type: "doughnut",
//               showInLegend: true,
//               dataPoints: dataPoints,
//             },
//           ],
//         });

//         chart.render();
//         const canvasjsCredit = document.querySelector(".canvasjs-chart-credit");
//         if (canvasjsCredit) {
//           canvasjsCredit.style.display = "none";
//         }
//       }
//     };
//     document.body.appendChild(script);
//     return () => {
//       document.body.removeChild(script);
//     };
//   }, [dashboardWeldCountByWelder]);

//   return (
//     <div
//       ref={chartContainerRef}
//       className="bg-white shadow rounded-lg h-[100%] w-[100%]"
//       // style={{ height: "100%", width: "100%", boxShadow: "0px 0px 0px 1px" }}
//     ></div>
//   );
// };

// export default ApexDonutPieChart;

import React, { useState } from "react";
import { useSelector } from "react-redux";

const ApexDonutPieChart = ({ inspectionProject }) => {
  const { dashboardWeldCountByWelder } = useSelector(
    (state) => state.dashboard,
  );

  console.log("dashboardWeldCountByWelder", dashboardWeldCountByWelder);
  const [hoveredIndex, setHoveredIndex] = useState(null);

  const data = dashboardWeldCountByWelder?.data || [];
  const total = data?.reduce((sum, item) => sum + item?.count, 0);

  const colors = [
    "#6366F1",
    "#06B6D4",
    "#10B981",
    "#F59E0B",
    "#F43F5E",
    "#F97316",
    "#8B5CF6",
    "#0EA5E9",
    "#EC4899",
    "#84CC16",
    "#14B8A6",
    "#2563EB",
  ];

  const outerRadius = 60;
  const innerRadius = 30;

  const calculateCoordinates = (startAngle, endAngle, radius) => {
    const x1 = radius * Math.cos(startAngle) + 75;
    const y1 = radius * Math.sin(startAngle) + 75;
    const x2 = radius * Math.cos(endAngle) + 75;
    const y2 = radius * Math.sin(endAngle) + 75;
    return { x1, y1, x2, y2 };
  };

  const createSlice = (startAngle, endAngle, percentage, item) => {
    const outer = calculateCoordinates(startAngle, endAngle, outerRadius);
    const inner = calculateCoordinates(startAngle, endAngle, innerRadius);

    const largeArcFlag = percentage > 0.5 ? 1 : 0;
    const path = [
      `M ${outer.x1} ${outer.y1}`,
      `A ${outerRadius} ${outerRadius} 0 ${largeArcFlag} 1 ${outer.x2} ${outer.y2}`,
      `L ${inner.x2} ${inner.y2}`,
      `A ${innerRadius} ${innerRadius} 0 ${largeArcFlag} 0 ${inner.x1} ${inner.y1}`,
      "Z",
    ].join(" ");

    return {
      path,
      percentage,
      endAngle,
      ...item,
    };
  };

  const slices =
    data?.length === 1
      ? [createSlice(-Math.PI / 2, (2.99 * Math.PI) / 2, 1, data[0])]
      : data.reduce((acc, item, index) => {
          const percentage = item.count / total;
          const startAngle =
            index === 0 ? -Math.PI / 2 : acc[index - 1].endAngle;
          const endAngle = startAngle + 2 * Math.PI * percentage;
          acc.push(createSlice(startAngle, endAngle, percentage, item));
          return acc;
        }, []);

  return (
    <div className="bg-white border border-slate-200 shadow-sm rounded-xl p-5 w-full h-full">
      <div className="flex justify-between items-start mb-4">
        <h2 className="text-xl sm:text-2xl font-semibold text-slate-800">
          {inspectionProject === 295
            ? "Weld Count by Inspector"
            : "Inspection Count by Inspector"}
        </h2>
      </div>

      <div className="justify-between flex">
        {data.length > 0 ? (
          <div>
            <svg viewBox="0 0 150 145" className="w-[195px] h-[195px]">
              {slices?.map((slice, index) => (
                <g key={slice._id}>
                  <path
                    d={slice.path}
                    fill={
                      hoveredIndex === index
                        ? colors[index]
                        : colors[index % colors.length]
                    }
                    style={{
                      filter:
                        hoveredIndex !== null && hoveredIndex !== index
                          ? "blur(2px)"
                          : "none",
                      transition: "filter 0.3s ease, transform 0.3s ease",
                      transform:
                        hoveredIndex === index ? "scale(1.1)" : "scale(1)",
                    }}
                    onMouseEnter={() => setHoveredIndex(index)}
                    onMouseLeave={() => setHoveredIndex(null)}
                  />
                  {hoveredIndex === index && (
                    <text
                      x={78}
                      y={78}
                      textAnchor="middle"
                      className="text-[12px] fill-slate-700 font-semibold"
                    >
                      {slice.count}
                      {/* {Math.round(slice.percentage * 100)}% */}
                    </text>
                  )}
                </g>
              ))}
            </svg>
          </div>
        ) : (
          <div className="text-center mt-4 text-gray-500">
            No data available to display.
          </div>
        )}
        <div className="flex flex-col gap-2">
          {data?.map((item, index) => (
            <div
              key={item._id}
              className="flex items-center gap-2 text-sm cursor-pointer"
              onMouseEnter={() => setHoveredIndex(index)}
              onMouseLeave={() => setHoveredIndex(null)}
            >
              <div
                className="w-3 h-3 rounded-sm"
                style={{ backgroundColor: colors[index % colors.length] }}
              />
              <span className="max-w-[160px] truncate text-slate-600 font-medium">
                {item.name}
              </span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ApexDonutPieChart;
